import React, { useState, useEffect, useRef } from "react";

/** Components */
import { Grid, ButtonGroup, TextField, TableRow, TableCell, TableHead, TableBody, Table, TableContainer, Button, Dialog, Select, MenuItem } from "@mui/material";
import { FilterBy } from "../../commons/filter.component";
import { TruckFTReview } from "../commons/fuelTicketPreview.component";
import ButtonWithAPICall from "../../commons/ButtonWithAPICall.component";
import CustomDatePicker from "../../commons/CustomDatePicker";

/** Icons */

/** Api & Function */
import { postConversion, getDriver, getCustomers, getInventory, getVehicle, getProduct, getProductUnit, createRefuelerTruckFT, replaceRefuelerTruckFT } from "../../../services/api";
import { setHeaderTitle } from "../../../store/layoutSlide";

/** Package */
import moment from "moment";

/** Hook */
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { useLocation, useHistory } from "react-router-dom";

const initialProduct = {
  vehicle: null,
  // refueler_no: null,
  hydrant_sys: "", //nhap
  position_no: "", //nhap
  driver: "", //nhap
  cert_no: "", //nhap
  meter_before_pump: "", //nhap
  meter_after_pump: "", //nhap
  product_id: null,
  product_name: null,
  productunit_id: null,
  product_unit: null,
  unit: null,
  density: "", //nhap
  temp: "", //nhap
  d15: "",
  vcf: "",
  wcf: "",
  l15: "",
  kg: "",
  lit: "",
  gallon: "",
  quantity: null,
  price_unit: null,
  amount: null,
  price_id: null,
  // vehicle_id: null,
  price_no: null,
};

const initialInput = {
  // saletype: null,
  // loadingtype: null,
  flight: null,
  inventory: null,
  flt: null,
  customer: null,
  billdate: "",
  // saleorder: null,
  // airline: null,
  aircraft: null,
  code_aircraft: "",
  start_date: "",
  end_date: "",
  note: "",
  invoiceproducts: [initialProduct],
  caltype: 1,
  product: null,
  cert_no: "",
  driver: null,
  loadsample: "",
  maxflow: "",
  diffpres: "",
  nozzlepres: "",
  vehicle: null,
  ext_inv_serial: "",
  vehicle_type: 1,
};
const CreateRefuelerTruckFT = () => {
  // hook
  const [t] = useTranslation();
  const user = useSelector((state) => state.user.data);
  const dispatch = useDispatch();

  const location = useLocation();
  const history = useHistory();
  // state
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [input, setInput] = useState({ ...initialInput });
  const data = {
    valid_date: moment(input.billdate).format("YYYY-MM-DD"),
    start_pump: moment(input.start_date).format("YYYY-MM-DD HH:mm"),
    end_pump: moment(input.end_date).format("YYYY-MM-DD HH:mm"),

    customer_id: input.customer?.id,
    customer_name: input.customer?.name,
    customer_tax: input.customer?.tax_code,
    customer_address: input.customer?.address,
    inventory_id: input.inventory?.id,
    hydrant_sys: input.inventory?.whtype,
    truck_id: input.vehicle?.id || null,
    refueler_license_plate: input.vehicle?.license_plate,
    vehicle_id: input.invoiceproducts[0].vehicle?.id,
    // eslint-disable-next-line eqeqeq
    position_no: input.inventory?.whtype == 3 ? input.invoiceproducts[0].position_no : undefined, // vi tri tra nap
    refueler_no: input.invoiceproducts[0].vehicle?.license_plate,

    cert_no: input.cert_no,
    meter_before_pump: input.invoiceproducts[0].meter_before_pump,
    meter_after_pump: input.invoiceproducts[0].meter_after_pump,
    density: (input.invoiceproducts[0].density / 10000).toFixed(4),
    temp: input.invoiceproducts[0].temp,
    d15: input.invoiceproducts[0].d15,
    vcf: input.invoiceproducts[0].vcf,
    wcf: input.invoiceproducts[0].wcf,
    l15: input.invoiceproducts[0].l15,
    kg: input.invoiceproducts[0].kg,
    lit: input.invoiceproducts[0].lit,
    gallon: input.invoiceproducts[0].gallon,
    quantity: input.invoiceproducts[0].meter_after_pump - input.invoiceproducts[0].meter_before_pump,
    ext_inv_serial: input.ext_inv_serial,
    provider_id: input.vehicle?.provider_id || null,
    provider_name: input.vehicle?.owner_company,

    product_name: input.product?.name,
    product_id: input.product?.id,
    productunit_code: input.invoiceproducts[0]?.unit?.shortname,
    productunit_id: input.invoiceproducts[0]?.unit?.id,
    note: input.note,
    driver: input.driver?.name,
    driver_id: input.driver?.id || null,

    loadsample: input.invoiceproducts[0].meter_after_pump - input.invoiceproducts[0].meter_before_pump,
    maxflow: input.maxflow,
    diffpres: input.diffpres,
    nozzlepres: input.nozzlepres,

    caltype: input.caltype,
  };
  const isReplace = Boolean(location.state?.id);
  // method
  const handleSubmit = () => {
    console.log(data);
    if (location.state?.id) return replaceRefuelerTruckFT(location.state.id, data);
    return createRefuelerTruckFT(data);
  };
  const handleSubmitResponse = (res) => {
    if (res.code === 200) history.push(`/fuelticket/${res.data?.id}?ft_type=${res.data.ft_type}`);
  };
  // effect
  useEffect(() => {
    if (!location.state) return;
    setInput((prev) => ({
      ...prev,
      caltype: location.state.caltype,
      billdate: moment(location.state.valid_date).format("YYYY-MM-DD"),
      vehicle_type: location.state.truck_id ? 0 : 1,
      vehicle: location.state.truck_id ? null : { license_plate: location.state.refueler_license_plate, owner_company: location.state.provider_name },
      driver: location.state.truck_id ? null : { name: location.state.driver },
      cert_no: location.state.cert_no,
      loadsample: location.state.loadsample,
      maxflow: location.state.maxflow,
      diffpres: location.state.diffpres,
      nozzlepres: location.state.nozzlepres,
      note: location.state.note,
      start_date: moment(location.state.start_pump).format("YYYY-MM-DD[T]HH:mm"),
      end_date: moment(location.state.end_pump).format("YYYY-MM-DD[T]HH:mm"),
      date: moment(location.state.valid_date).format("YYYY-MM-DD"),
      invoiceproducts: [
        {
          ...initialProduct,
          position_no: location.state.position_no,
          meter_after_pump: location.state.meter_after_pump,
          meter_before_pump: location.state.meter_before_pump,
          temp: location.state.temp,
          density: Math.round(location.state.density * 10000),
        },
      ],
    }));
  }, [location.state]);

  useEffect(() => {
    dispatch(setHeaderTitle((isReplace ? "PHÁT HÀNH THAY THẾ" : "TẠO") + " PHIẾU XUẤT TRẢ HÀNG GỬI TỪ XE TRA NẠP SANG XE BỒN"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ margin: 5, marginTop: 15 }}>
      {/* <button onClick={() => setA(a+1)}>click</button> */}
      {/* <h1>{t((isReplace ? "Phát hành thay thế" : "Tạo") + " phiếu xuất trả hàng gửi từ xe tra nạp sang xe bồn")}</h1> */}
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <FilterBy
            label={t("Khách hàng")}
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, customer: option.find((item) => item.id === location.state.customer_id) }))}
            triggerSetDefaultFunc={location.state}
            getDataFunc={() => getCustomers({ status: 1 })}
            value={input.customer}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, customer: newValue }))}
          />
        </Grid>
        <Grid item xs={3}>
          <FilterBy
            label={t("Kho xuất")}
            getDataFunc={() => getInventory({ status: 1, organization_id: user?.organization_id })}
            triggerGetDataFunc={Boolean(user)}
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, inventory: option.find((item) => item.id === location.state.inventory_id) }))}
            triggerSetDefaultFunc={Boolean(location.state)}
            value={input.inventory}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, inventory: newValue, invoiceproducts: prev.invoiceproducts.map((item) => ({ ...item, vehicle: null, position_no: "" })) }))}
          />
        </Grid>
        <Grid item xs={3}>
          <CustomDatePicker
            format="DD/MM/YYYY HH:mm:ss"
            outputFormat="YYYY-MM-DD HH:mm"
            label={t("Thời gian bắt đầu")}
            value={input.start_date}
            onChange={(value) => setInput((prev) => ({ ...prev, start_date: value }))}
            sx={{ width: "100%" }}
          />
        </Grid>
        <Grid item xs={3}>
          <CustomDatePicker
            format="DD/MM/YYYY HH:mm:ss"
            outputFormat="YYYY-MM-DD HH:mm"
            label={t("Thời gian kết thúc")}
            value={input.end_date}
            onChange={(value) => setInput((prev) => ({ ...prev, end_date: value }))}
            sx={{ width: "100%" }}
          />
        </Grid>
        <Grid item xs={3}>
          <Select fullWidth size="small" value={input.vehicle_type || 0} align="left" onChange={(e) => setInput((prev) => ({ ...prev, vehicle_type: e.target.value, vehicle: null, driver: null }))}>
            <MenuItem value={0}>Phương tiện trong hệ thống</MenuItem>
            <MenuItem value={1}>Phương tiện ngoài hệ thống</MenuItem>
          </Select>
        </Grid>
        <Grid item xs={3}>
          {input.vehicle_type ? (
            <TextField
              fullWidth
              label={t("Phương tiện")}
              value={input.vehicle?.license_plate || ""}
              onChange={(e) => setInput((prev) => ({ ...prev, vehicle: { ...prev.vehicle, license_plate: e.target.value } }))}
            />
          ) : (
            <FilterBy
              fullWidth
              label={t("Phương tiện")}
              getDataFunc={() => getVehicle({ status: 1, end_date: moment(Date.now()).format("YYYY-MM-DD"), groupvehicle_id: 455911 })}
              setDefaultFunc={(option) => location.state && setInput((prev) => ({ ...prev, vehicle: option.find((item) => item.id === location.state.truck_id) }))}
              triggerSetDefaultFunc={location.state}
              value={input.vehicle}
              getOptionLabel={(option) => `${option.id} - ${option.license_plate}` || ""}
              filter={(option) => option.provider_id && JSON.parse(option.tanks)?.length}
              onChange={(e, newValue) => setInput((prev) => ({ ...prev, vehicle: newValue, driver: null }))}
            />
          )}
        </Grid>
        <Grid item xs={3}>
          <TextField
            fullWidth
            label="Công ty vận tải"
            disabled={!input.vehicle_type}
            value={input.vehicle?.owner_company || ""}
            onChange={(e) => setInput((prev) => ({ ...prev, vehicle: { ...prev.vehicle, owner_company: e.target.value } }))}
          />
        </Grid>
        <Grid item xs={3}>
          {input.vehicle_type ? (
            <TextField fullWidth label={t("Người điều khiển")} value={input.driver?.name || ""} onChange={(e) => setInput((prev) => ({ ...prev, driver: { ...prev.driver, name: e.target.value } }))} />
          ) : (
            <FilterBy
              fullWidth
              disabled={!input.vehicle}
              label={t("Người điều khiển")}
              getDataFunc={() => input.vehicle && getDriver({ provider_id: input.vehicle?.provider_id, status: 1 })}
              getDataDependencies={[input.vehicle]}
              filter={(option) => option.provider_id === input.vehicle?.provider_id}
              setDefaultFunc={(_, option) => location.state && setInput((prev) => ({ ...prev, driver: option.find((item) => item.id === location.state.driver_id) || null }))}
              triggerSetDefaultFunc={location.state}
              setDefaultDependencies={[location.state]}
              value={input.driver}
              getOptionLabel={(option) => option.name || ""}
              onChange={(e, newValue) => setInput((prev) => ({ ...prev, driver: newValue }))}
            />
          )}
        </Grid>
        <Grid item xs={3}>
          <TextField
            label={t("Lượng nạp")}
            fullWidth
            value={input.invoiceproducts[0].meter_after_pump - input.invoiceproducts[0].meter_before_pump || ""}
            onChange={(e) => setInput((prev) => ({ ...prev, loadsample: e.target.value }))}
            disabled
          />
        </Grid>
        <Grid item xs={3}>
          <TextField label={t("Lưu lượng")} fullWidth value={input.maxflow || ""} onChange={(e) => setInput((prev) => ({ ...prev, maxflow: e.target.value }))} />
        </Grid>
        <Grid item xs={3}>
          <TextField
            label={t("Chênh áp")}
            fullWidth
            value={input.diffpres || ""}
            onChange={(e) => (e.target.value === "" || (e.target.value > 0 && e.target.value < 15)) && setInput((prev) => ({ ...prev, diffpres: e.target.value }))}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            label={t("Áp suất đầu vòi")}
            fullWidth
            value={input.nozzlepres || ""}
            onChange={(e) => (e.target.value === "" || (e.target.value > 0 && e.target.value < 45)) && setInput((prev) => ({ ...prev, nozzlepres: e.target.value }))}
          />
        </Grid>
        <Grid item xs={3}>
          <FilterBy
            disabled
            label={t("Tên hàng hóa")}
            getDataFunc={() => getProduct({ status: 1 })}
            triggerSetDefaultFunc={true}
            setDefaultFunc={(option) => setInput((prev) => ({ ...prev, product: option.find((item) => (location.state ? item.id === location.state.product_id : item.id === 455496)) || null }))}
            value={input.product}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, product: newValue }))}
          />
        </Grid>
        <Grid item xs={3}>
          <TextField fullWidth label={t("Chứng chỉ số")} onChange={(e) => setInput((prev) => ({ ...prev, cert_no: e.target.value }))} value={input.cert_no} />
        </Grid>
        {/* <Grid item xs={3}>
                    <TextField
                    fullWidth
                    label={t('Phiếu nhập/Ký hiệu')}
                    onChange={e => setInput(prev => ({ ...prev, ext_inv_serial: e.target.value }))}
                        value={input.ext_inv_serial}
                        />
                    </Grid> */}
        <Grid item xs={3}>
          <CustomDatePicker format="DD/MM/YYYY" label={t("Ngày thực hiện")} value={input.billdate} onChange={(value) => setInput((prev) => ({ ...prev, billdate: value }))} sx={{ width: "100%" }} />
        </Grid>
        <Grid item xs={3}>
          <TextField label={"Ghi chú"} fullWidth value={input.note} onChange={(e) => setInput((prev) => ({ ...prev, note: e.target.value }))} />
        </Grid>
      </Grid>
      <ProductTable input={input} setInput={setInput} />
      <div align="left">
        {/* button is disabled if required field is empty */}
        <ButtonGroup style={{ margin: 5 }}>
          <Button variant="contained" onClick={() => setDialogOpen(true)} color="info">
            {t("Xem trước")}
          </Button>
          <ButtonWithAPICall variant="contained" api={handleSubmit} response={handleSubmitResponse}>
            {t(isReplace ? "Phát hành thay thế" : "Tạo phiếu")}
          </ButtonWithAPICall>
        </ButtonGroup>
      </div>
      <Dialog onClose={() => setDialogOpen(false)} open={isDialogOpen}>
        <TruckFTReview data={{ ...data, inventory_name: input.inventory?.name }} />
      </Dialog>
    </div>
  );
};

export default CreateRefuelerTruckFT;
const ProductTable = ({ input, setInput }) => {
  const [t] = useTranslation();
  const productRef = useRef();
  const location = useLocation();
  //redux state
  const user = useSelector((state) => state.user.data);

  useEffect(() => {
    input.invoiceproducts.forEach((item, index) => {
      handleChangeReceiptProduct(index, "temp", item.temp);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [input.caltype]);

  useEffect(() => {
    productRef.current = input.invoiceproducts;
  }, [input.invoiceproducts]);
  const handleChangeReceiptProduct = (index, keyName, value) => {
    let newProduct = [...input.invoiceproducts];
    newProduct[index][keyName] = value;
    if (["temp", "density", "unit", "meter_before_pump", "meter_after_pump"].includes(keyName)) {
      newProduct[index] = {
        ...newProduct[index],
        lit: "",
        d15: "",
        vcf: "",
        wcf: "",
        l15: "",
        kg: "",
        gallon: "",
      };
      switch (keyName) {
        case "temp":
          newProduct[index].temp_error = newProduct[index].temp < 4.5 || newProduct[index].temp > 52 ? "Temp must be in range 4.5 - 52" : undefined;
          break;
        case "density":
          newProduct[index].density_error = newProduct[index].density < 7000 || newProduct[index].density > 8730 ? "Density must be in range 7000 - 8730" : undefined;
          break;
        default:
          break;
      }
      // kiem tra dieu kien, neu thoa man thi goi api convert
      if (
        newProduct[index].meter_after_pump.toString() &&
        newProduct[index].meter_before_pump.toString() &&
        newProduct[index].unit &&
        newProduct[index].temp &&
        newProduct[index].density &&
        !newProduct[index].temp_error &&
        !newProduct[index].density_error
      ) {
        let { meter_before_pump, meter_after_pump, unit, temp, density } = newProduct[index];
        newProduct[index].loadingState = true;
        postConversion({
          quantity: meter_after_pump - meter_before_pump,
          unit: unit.id,
          temp: temp,
          density: density / 10000,
          method: input.caltype,
        }).then((res) => {
          if (
            // kiem tra xem du lieu cu co giong du lieu hien tai khong, neu khong giong thi k update
            res.code === 200 &&
            meter_before_pump === productRef.current[index].meter_before_pump &&
            meter_after_pump === productRef.current[index].meter_after_pump &&
            unit === productRef.current[index].unit &&
            temp === productRef.current[index].temp &&
            density === productRef.current[index].density
          ) {
            newProduct = productRef.current;
            newProduct[index] = {
              ...newProduct[index],
              lit: res.data.lit,
              d15: res.data.d15,
              vcf: res.data.vcf,
              wcf: res.data.wcf,
              l15: res.data.l15,
              kg: res.data.kg,
              gallon: res.data.gallon,
              loadingState: undefined,
            };
            setInput((prev) => ({ ...prev, invoiceproducts: newProduct }));
          }
        });
      }
    }
    setInput((prev) => ({ ...prev, invoiceproducts: newProduct }));
  };
  return (
    <>
      <div style={{ padding: 10, fontSize: 17, backgroundColor: "#f0f3f5", marginTop: 20, textTransform: "uppercase" }}>{t("Thông tin hàng hóa")}</div>
      <div align="left" style={{ display: "flex", alignItems: "center" }}>
        <ButtonGroup>
          <Button onClick={() => input.caltype !== 1 && setInput((prev) => ({ ...prev, caltype: 1 }))} style={{ backgroundColor: input.caltype === 1 ? "lightblue" : "" }}>
            KG = L15 * WCF
          </Button>
          <Button onClick={() => input.caltype !== 2 && setInput((prev) => ({ ...prev, caltype: 2 }))} style={{ backgroundColor: input.caltype === 2 ? "lightblue" : "" }}>
            KG = LTT * DENSITY
          </Button>
        </ButtonGroup>
      </div>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center">Xe tra nạp số</TableCell>
              <TableCell align="center">*Số công tơ đầu</TableCell>
              <TableCell align="center">*Số công tơ cuối</TableCell>
              <TableCell align="center">Khối lượng</TableCell>
              <TableCell align="center">Đơn vị</TableCell>
              <TableCell align="center">°C</TableCell>
              <TableCell align="center">*{t("Tỷ trọng")}</TableCell>
              <TableCell align="center">D15</TableCell>
              <TableCell align="center">VCF</TableCell>
              <TableCell align="center">WCF</TableCell>
              <TableCell align="center">
                {t("Số lượng")} ({t("lit")} 15℃)
              </TableCell>
              <TableCell align="center">{t("Số lượng")} (kg)</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {input.invoiceproducts?.map((item, index) => (
              <TableRow key={index}>
                <TableCell>
                  <FilterBy
                    getDataFunc={() => getVehicle({ status: 1, organization_id: user?.organization_id, end_date: moment(Date.now()).format("YYYY-MM-DD") })}
                    triggerGetDataFunc={Boolean(input.inventory && user)}
                    setDefaultFunc={(option) =>
                      handleChangeReceiptProduct(
                        0,
                        "vehicle",
                        option.find((item) => item.license_plate === location.state.refueler_no)
                      )
                    }
                    triggerSetDefaultFunc={Boolean(location.state)}
                    value={item.vehicle}
                    sx={{ width: "200px" }}
                    // filter={item => item.organization_id === user?.organization_id && item.groupvehicle_type === loadingtype && ((item.groupvehicle_code === '00' && input.inventory?.whtype === '2') || (item.groupvehicle_code === '01' && input.inventory?.whtype == '3'))}
                    disabled={!input.inventory}
                    getOptionLabel={(option) => option.license_plate || ""}
                    onChange={(e, newValue) => handleChangeReceiptProduct(index, "vehicle", newValue)}
                  />
                </TableCell>
                <TableCell align="center">
                  <TextField
                    fullWidth
                    type="number"
                    InputProps={{ style: { width: 150 } }}
                    onChange={(e) => e.target.value >= 0 && handleChangeReceiptProduct(index, "meter_before_pump", e.target.value)}
                    value={item.meter_before_pump}
                  />
                </TableCell>
                <TableCell align="center">
                  <TextField
                    fullWidth
                    type="number"
                    InputProps={{ style: { width: 150 } }}
                    value={item.meter_after_pump}
                    onChange={(e) => e.target.value >= 0 && handleChangeReceiptProduct(index, "meter_after_pump", e.target.value)}
                  />
                </TableCell>
                <TableCell align="center">
                  <TextField fullWidth InputProps={{ style: { width: 150 } }} disabled value={Math.round(item.meter_after_pump - item.meter_before_pump)?.toLocaleString()} />
                </TableCell>
                <TableCell align="center">
                  <FilterBy
                    getDataFunc={() => getProductUnit({ status: 1 })}
                    value={item.unit}
                    triggerSetDefaultFunc={true}
                    setDefaultFunc={(_, option) =>
                      handleChangeReceiptProduct(
                        index,
                        "unit",
                        option.find((item) => (location.state ? item.id === location.state.productunit_id : item.id === 21))
                      )
                    }
                    onChange={(e, newValue) => handleChangeReceiptProduct(index, "unit", newValue)}
                    filter={(option) => [21, 22].includes(option.id)}
                    style={{ width: 100 }}
                    getOptionLabel={(option) => option.name || ""}
                    label={t("Đơn vị tính")}
                    disableClearable
                  />
                </TableCell>
                <TableCell align="center">
                  <TextField
                    fullWidth
                    inputProps={{ style: { textAlign: "center", width: 50 } }}
                    value={item.temp}
                    error={(item.temp < 4.5 || item.temp > 52) && item.temp !== ""}
                    helperText={item.temp < 4.5 || item.temp > 52 ? "(4-52)" : " "}
                    style={{ paddingTop: 20 }}
                    onChange={(e) => handleChangeReceiptProduct(index, "temp", e.target.value)}
                  />
                </TableCell>
                <TableCell align="center">
                  <TextField
                    fullWidth
                    inputProps={{ style: { textAlign: "center", width: 75 } }}
                    value={item.density}
                    error={(item.density < 7001 || item.density > 8730) && item.density !== ""}
                    helperText={item.density < 7001 || item.density > 8730 ? "(7001-8730)" : " "}
                    style={{ paddingTop: 20 }}
                    onChange={(e) => handleChangeReceiptProduct(index, "density", e.target.value)}
                  />
                </TableCell>
                <TableCell align="center">{item.d15 && parseFloat(item.d15)?.toFixed(4)}</TableCell>
                <TableCell align="center">{item.vcf && parseFloat(item.vcf)?.toLocaleString()}</TableCell>
                <TableCell align="center">{item.wcf && parseFloat(item.wcf)?.toLocaleString()}</TableCell>
                <TableCell align="center">{Math.round(item.l15)?.toLocaleString()}</TableCell>
                <TableCell align="center">{Math.round(item.kg)?.toLocaleString()}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
